module.exports = __webpack_public_path__ + "static/media/james.4a9f3452.jpg";